import { controlledProductsActions } from '../actions'
const {
  FETCH_PRODUCTS,
  FETCHING_PRODUCTS,
  FETCH_PRODUCT,
  FETCHING_PRODUCT,
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCT_ERROR
} = controlledProductsActions

const initialState = {
  fetching: {
    product: false,
    products: false
  },
  items: [],
  product: {},
  last_update: undefined,
  fetch_errors: {
    product: false,
    products: false
  }
}

const controlledProducts = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return {
        ...state, last_update: action.last_update, items: action.items, fetching: { ...state.fetching, products: false },
        fetch_errors: {
          ...state.fetch_errors,
          products: false
        }
      }
    case FETCHING_PRODUCTS:
      return { ...state, fetching: { ...state.fetching, products: action.value } }
    // // Single Product
    case FETCH_PRODUCT:
      return {
        ...state, product: action.product, fetching: { ...state.fetching, product: false },
        fetch_errors: {
          ...state.fetch_errors,
          product: false
        }
      }
    case FETCHING_PRODUCT:
      return { ...state, fetching: { ...state.fetching, product: action.value } }
    // // Erros
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          products: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          products: true
        }
      }
    case FETCH_PRODUCT_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          product: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          product: true
        }
      }
    default:
      return state
  }
}


export default controlledProducts



// WEBPACK FOOTER //
// ./src/reducers/controlledProducts.js